var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"pages"}},[_c('h5',[_vm._v("404")]),_c('span',{on:{"click":function($event){return _vm.$router.back(-1)}}},[_vm._v(_vm._s(_vm.$t("Back to previous page")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }